import React from "react";
import PropTypes from "prop-types";
import { Table as BTable } from "react-bootstrap";
import { flexRender } from "@tanstack/react-table";

function Tabelas({ table, handleRowClick, fixLastColumn }) {
  return (
    <div>
      <BTable
        hover
        responsive
        size="sm"
        className={`tabelas text-nowrap ${fixLastColumn ? "fix-last-column" : ""}`}
      >
        <thead className="tabel-cabecalho">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index) => (
                <th
                  onClick={header.column.getToggleSortingHandler()}
                  key={header.id}
                  colSpan={header.colSpan}
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                  {index !== headerGroup.headers.length - 1
                    ? ({
                        asc: <i className="icn-header bi bi-arrow-up" />,
                        desc: <i className="icn-header bi bi-arrow-down" />,
                      }[header.column.getIsSorted()] ?? (
                        <i className="icn-header bi bi-arrow-down-up" />
                      ))
                    : ""}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <TableRow key={row.id} row={row} handleRowClick={handleRowClick} />
          ))}
        </tbody>
      </BTable>
    </div>
  );
}

Tabelas.propTypes = {
  table: PropTypes.object.isRequired,
  handleRowClick: PropTypes.func,
  fixLastColumn: PropTypes.bool,
};

const TableRow = React.memo(({ row, handleRowClick }) => (
  <tr onClick={() => handleRowClick && handleRowClick(row.original.ToSenseID)}>
    {row.getVisibleCells().map((cell) => (
      <td key={cell.id}>
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </td>
    ))}
  </tr>
));

TableRow.propTypes = {
  row: PropTypes.object.isRequired,
  handleRowClick: PropTypes.func,
};

TableRow.displayName = "TableRow";

export default Tabelas;
